import React from 'react';
import { connect } from 'react-redux';

export const Loading = ({ isLoading }) => (
  <div>
    {isLoading && (
      <div
        className="ajax-overlay justify-content-center"
      >
        <i style={{ fontSize: '40px', color: 'white' }} className="fas fa-spinner fa-spin" />
      </div>
    )}
  </div>
);

const mapStateToProps = state => ({
  isLoading: (state.loading > 0),
});

export default connect(mapStateToProps)(Loading);
